<script>
import icons from './icons'

export default {
  name: 'FeatherIcon',
  functional: true,
  props: {
    icon: {
      required: true,
      type: [String, Object],
    },
    size: {
      type: String,
      default: '14',
    },
    badge: {
      type: [String, Object, Number],
      default: null,
    },
    badgeClasses: {
      type: [String, Object, Array],
      default: 'badge-primary',
    },
  },
  render(h, { props, data }) {
    // Create Feather Icon
    const iconComponent = typeof props.icon === 'string' ? icons[props.icon] : props.icon
    if (!iconComponent) {
      // eslint-disable-next-line no-console
      console.warn(`[FeatherIcon] "${props.icon}" is not registered; add it to ./icons.js`)
      return h('span', { ...data, style: { display: 'inline-block', width: `${props.size}px`, height: `${props.size}px` } })
    }
    const svg = h(iconComponent, { props: { size: props.size }, ...data })

    // If no badge is provided => Render just SVG
    if (!props.badge) return svg

    // Badge
    const badgeEl = h('span', { staticClass: 'badge badge-up badge-pill', class: props.badgeClasses }, [props.badge])

    // Return span with children
    return h('span', { staticClass: 'feather-icon position-relative' }, [svg, badgeEl])
  },
}
</script>

<style lang="scss">
svg.feather {
  outline: none
}
</style>
